module.exports = __webpack_public_path__ + "img/pic-heart.2b99710.svg";